import type { LocationRecordModel } from "@/utils/PocketBaseAdapter";
import { pb } from "@/utils/PocketBaseAdapter";
import { defineStore } from "pinia";

export const useLocationStore = defineStore("LocationStore", {
  state: () => ({
    locations: new Map<string, LocationRecordModel>(),
    locationList: [] as LocationRecordModel[],
  }),
  getters: {
    resolveLocationIdToName(state) {
      return (locationId: string) => {
        return state.locations.get(locationId)?.name;
      };
    },
  },
  actions: {
    async refreshLocations() {
      try {
        this.locations.clear();

        const locations = await pb.collection("locations").getFullList({
          requestKey: null,
          filter: "enabled = true",
        });

        this.locationList = locations;
        locations.forEach((location) =>
          this.locations.set(location.id, location)
        );
      } catch (error) {}
    },
  },
});

// useLocationStore().refreshLocations();
